export type ChatMessageLike = {
  id: string
  sender_id: string
  body: string
  created_at: string
  hasAttachment?: boolean
  attachmentUrl?: string | null
  readByPeer?: boolean
  blocked?: boolean
  blockReason?: string | null
  blockCategory?: string | null
}

export function formatMessageTime(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const now = new Date()
  const sameDay = d.toDateString() === now.toDateString()
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  if (sameDay) return time
  return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} · ${time}`
}

export function mergeChatMessages<T extends ChatMessageLike>(prev: T[], incoming: T[]): T[] {
  if (!incoming.length) return prev
  if (
    prev.length === incoming.length &&
    prev.every(
      (m, i) =>
        m.id === incoming[i]?.id &&
        m.body === incoming[i]?.body &&
        m.readByPeer === incoming[i]?.readByPeer &&
        m.blocked === incoming[i]?.blocked,
    )
  ) {
    return prev
  }
  return incoming
}

export function appendUniqueMessage<T extends ChatMessageLike>(prev: T[], message: T): T[] {
  if (prev.some((m) => m.id === message.id)) return prev
  return [...prev, message]
}

export const THREAD_POLL_MS = 2000
export const INBOX_POLL_MS = 5000
